import React, { useCallback } from "react";
import PropTypes from "prop-types";
import PrimaryButton from "components/v3/primary-button/PrimaryButton";
import { BUTTON_THEME_BLUE_MEDIUM } from "components/v3/primary-button/themes";
import { FEEDBACK_URL } from "common/constants/Constants";
import {
    formatOfferPrice,
    formatIntroPeriod,
    getNumberOfPeriodsInMonth
} from "common/utils/subscriptionCopyHelpers";
import GoogleTracking from "services/GoogleTracking";
import styles from "./styles.module.scss";

const OfferScreen = ({
    allOffers,
    setSelectedOffer,
    next
}) => {
    const focusOnButton = useCallback((node) => {
        node && node.focus();
    }, []);

    return (
        <>
            <div className={ styles.modalMessage }>
                We don&apos;t want to see you go!
            </div>
            <OfferList
                allOffers={ allOffers }
                next={ next }
                setSelectedOffer={ setSelectedOffer }
            />
            <div className={ styles.linkGroup }>
                <a className={ styles.feedbackLink } ref={ focusOnButton } target="_blank" href={ FEEDBACK_URL }>
                    No thanks, I&apos;ll cancel
                </a>
            </div>
        </>
    );
};

OfferScreen.propTypes = {
    allOffers: PropTypes.array.isRequired,
    setSelectedOffer: PropTypes.func.isRequired,
    next: PropTypes.func.isRequired,
    thinking: PropTypes.string
};

const OfferList = ({ allOffers, setSelectedOffer, next }) => {
    const onSelect = useCallback(async (index) => {
        GoogleTracking.registerSaveOfferEvent("subscriber_save_tout");
        await setSelectedOffer(index);
        next();
    }, [setSelectedOffer, next]);

    return (
        allOffers.map((offer, index) => {
            const {
                pricing: {
                    total,
                    totalWithDiscount,
                    billingPeriod,
                    totalDiscount,
                    discountLength,
                    discountPeriod,
                    hasDiscount
                }
            } = offer;

            return (
                <div className={ styles.outerBox } key={ `offer_${ index }` }>
                    <div className={ styles.saveDollarText }>
                        Save ${ Math.floor(totalDiscount / getNumberOfPeriodsInMonth(discountPeriod)) }/month
                    </div>
                    <div className={ styles.triangle } />
                    <div className={ styles.savePercentage }>
                        Save { Math.floor(totalDiscount / total * 100) }%
                    </div>
                    <div className={ styles.saveMainText }>
                        Reduce your payment to just {
                            formatOfferPrice({
                                total,
                                totalWithDiscount,
                                billingPeriod,
                                discountPeriod,
                                hasDiscount,
                                discountLength
                            })
                        } {
                            hasDiscount && `for ${ formatIntroPeriod({
                                discountPeriod,
                                discountLength
                            }) }${ discountLength > 1 ? "s" : "" }`
                        }.
                    </div>
                    <div className={ styles.buttonGroup }>
                        <PrimaryButton
                            type="button"
                            theme={ BUTTON_THEME_BLUE_MEDIUM }
                            onClick={ onSelect.bind(this, index) }
                            text="Claim this offer"
                        />
                    </div>
                </div>
            );
        })
    );
};

OfferList.propTypes = {
    allOffers: PropTypes.array.isRequired,
    setSelectedOffer: PropTypes.func.isRequired,
    next: PropTypes.func.isRequired
};

export default OfferScreen;
